module.exports = __webpack_public_path__ + "static/shobhaben-5f3590911e54b2c04ad08ee016bffff5.webp";